import { ErrorType } from '$types/error';
import { browser, dev } from '$app/environment';
import { PUBLIC_ENV } from '$env/static/public';
import { stateError } from '$states/error.svelte';
import type { Address } from '$types/address';
import { CONTEXTS } from '$lib/constants/contexts';
import { GrowthBook } from '@growthbook/growthbook';
import { setGrowthBook } from '$services/growthBook';
import { redirect } from '@sveltejs/kit';

export const prerender = false;
export const ssr = false;

export const load = async (event) => {
  if (
    !event.url.pathname.startsWith('/welcome') &&
    !event.url.pathname.startsWith('/migrate-domain') &&
    !event.url.pathname.startsWith('/migrate-safe') &&
    event.url.pathname !== '/'
  ) {
    throw redirect(301, '/migrate-domain');
  }
  const GROWTH_BOOK_MAP = {
    production: 'sdk-enWjfiPKjRhfUeA',
    local: 'sdk-RNp48t0Bby2twav0',
    'deploy-preview': 'sdk-6Jw8k3ET4Jilnpys',
    branch: 'sdk-HB5rAlKQmwIMp3hO',
    kitchen: 'sdk-liYcZQYJyKclZUD5',
  };

  const growthBook = new GrowthBook({
    apiHost: 'https://cdn.growthbook.io',
    clientKey: GROWTH_BOOK_MAP[PUBLIC_ENV as keyof typeof GROWTH_BOOK_MAP],
    enableDevMode: dev,
  });

  setGrowthBook(growthBook);

  await growthBook.init({ streaming: true });
};

if (browser) {
  window['__i'] = (address: Address) => {
    const oldAddress = localStorage.getItem('metriAddress');
    localStorage.setItem('metriAddress', address);
    localStorage.setItem(
      `cometh-connect-${address}`,
      localStorage.getItem(`cometh-connect-${oldAddress}`) ?? '',
    );
    window.location.reload();
  };

  const context = new URL(window.location.href).searchParams.get('context');
  if (browser && context && CONTEXTS.includes(context)) {
    localStorage.setItem('context', context);
  }
}

const checkServiceWorkerCompatibility = (): void => {
  if (!browser) {
    return;
  }

  if (!('serviceWorker' in navigator)) {
    stateError.set({
      type: ErrorType.SILENT,
      rawError: null,
      message: 'Client has no ServiceWorker Capability',
      severity: 'fatal',
    });
  }
};

const registerServiceWorker = async (): Promise<void> => {
  if ('serviceWorker' in navigator) {
    await navigator.serviceWorker.register('/service-worker.js', {
      type: 'module',
    });
  }
};

export const _serviceWorker = async (): Promise<void> => {
  if (!browser) {
    return;
  }

  checkServiceWorkerCompatibility();

  await registerServiceWorker();

  return;
};
